import React, { useRef, useEffect } from 'react';
import '../assets/styles/TypeWriter.css'; // Import your CSS file for styling

const TypeWriter = () => {
// Removed unused canvasRef

useEffect(() => {
    // Find the hero text element
    const textElement = document.querySelector(".hero-text h1");
    if (!textElement) return;

    // Array of phrases to cycle through
    const phrases = [
        "Build - Break - Secure",
        "Recon - Breach - Fortify",
        "Exploit the Limits - Patch the Future",
        "Crafted in Code - Forged in Curiosity",
        "Think Like an Attacker - Defend Like a Wall",
        "Signal In - Noise Out"
    ];

    let phraseIndex = 0;
    let charIndex = 0;
    let isTyping = true;

    // Clear the content before starting
    textElement.textContent = "";

    const typeWriter = () => {
        if (!isTyping) return;

        if (charIndex < phrases[phraseIndex].length) {
            textElement.textContent += phrases[phraseIndex].charAt(charIndex);
            charIndex++;
            setTimeout(typeWriter, 150);
        } else {
            isTyping = false;
            setTimeout(() => {
                textElement.textContent = "";
                charIndex = 0;
                phraseIndex = (phraseIndex + 1) % phrases.length;
                isTyping = true;
                typeWriter();
            }, 2000);
        }
    };

    typeWriter();

    // Cleanup function to stop typing if unmounted
    return () => {
        isTyping = false;
    };

}, []);
};

export default TypeWriter;
